import { render, staticRenderFns } from "./MapsDoctor.vue?vue&type=template&id=49a14b42&scoped=true&"
import script from "./MapsDoctor.vue?vue&type=script&lang=js&"
export * from "./MapsDoctor.vue?vue&type=script&lang=js&"
import style0 from "./MapsDoctor.vue?vue&type=style&index=0&id=49a14b42&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49a14b42",
  null
  
)

export default component.exports